/* AnalogSetup — interacciones propias (galería, cantidad y barra de compra) */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- Galería */
  function initGallery(root) {
    var stage = root.querySelector('[data-al-stage]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-al-thumb]'));
    if (!stage || thumbs.length === 0) return;

    var slides = Array.prototype.slice.call(stage.querySelectorAll('img'));

    function show(index) {
      slides.forEach(function (img, i) {
        img.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (btn, i) {
        btn.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        show(i);
      });
      btn.addEventListener('mouseenter', function () {
        show(i);
      });
    });

    show(0);
  }

  /* -------------------------------------------------------------- Cantidad */
  function initQuantity(root) {
    var input = root.querySelector('[data-al-qty-input]');
    if (!input) return;

    root.querySelectorAll('[data-al-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.getAttribute('data-al-qty') === 'plus' ? 1 : -1;
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function addToCart(variantId, btn) {
    if (!variantId) return Promise.resolve();

    var errorEl = document.querySelector('[data-al-upsell-error]');
    if (errorEl) errorEl.hidden = true;
    if (btn) btn.setAttribute('aria-busy', 'true');

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
    }

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    return fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || response.message || 'No se ha podido añadir');
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return response;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'analog-add',
            productVariantId: variantId,
            cartData: response,
          });
        }

        if (cart && typeof cart.open === 'function') {
          cart.open(btn || cart);
        }

        return response;
      })
      .catch(function (error) {
        var el = document.querySelector('[data-al-upsell-error]');
        if (el) {
          el.textContent = error.message;
          el.hidden = false;
        }
        throw error;
      })
      .finally(function () {
        if (btn) btn.removeAttribute('aria-busy');
      });
  }

  /* ------------------------------------------------------------ Barra fija */
  function initStickyBar() {
    var bar = document.querySelector('[data-al-stickybar]');
    if (!bar) return;

    var anchorId = bar.getAttribute('data-al-anchor');
    var anchor = anchorId ? document.getElementById(anchorId) : null;
    var footer = document.querySelector('.footer');

    var cta = bar.querySelector('[data-al-cta]');

    function setMode(count) {
      if (!cta) return;
      var hasItems = count > 0;
      cta.dataset.mode = hasItems ? 'cart' : 'buy';
      cta.textContent = hasItems
        ? cta.dataset.labelCart || 'Ver carrito'
        : cta.dataset.labelBuy || 'Comprar';
    }

    if (cta && !cta.dataset.alBound) {
      cta.dataset.alBound = 'true';

      cta.addEventListener('click', function (event) {
        if (cta.dataset.mode === 'cart') {
          event.preventDefault();
          event.stopPropagation();
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open(cta);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        }
      });

      var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      fetch(cartUrl + '.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          setMode(cart.item_count);
        })
        .catch(function () {});

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          var count = event && event.cartData ? event.cartData.item_count : null;
          setMode(typeof count === 'number' ? count : 1);
        });
      }
    }

    function update() {
      var pastAnchor = anchor ? anchor.getBoundingClientRect().bottom < 0 : window.scrollY > 700;
      var atFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      bar.classList.toggle('is-visible', pastAnchor && !atFooter);
    }

    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      },
      { passive: true }
    );

    update();
  }

  /* --------------------------------------------------- Scroll suave a compra */
  function initAnchors() {
    document.querySelectorAll('[data-al-scroll-to]').forEach(function (el) {
      el.addEventListener('click', function (event) {
        var target = document.getElementById(el.getAttribute('data-al-scroll-to'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ------------------------------------------ Añadir al carrito (hero, CTA, upsell) */
  function initAddToCart() {
    if (document.body.dataset.alAddBound) return;
    document.body.dataset.alAddBound = 'true';

    document.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('[data-al-add-to-cart], [data-al-upsell-add]');
      if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
      if (btn.hasAttribute('data-al-cta') && btn.dataset.mode === 'cart') return;

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      event.preventDefault();
      addToCart(variantId, btn);
    });
  }

  /* --------------------------------------------------- Viendo ahora + toasts */
  function initViewing() {
    document.querySelectorAll('[data-al-viewing]').forEach(function (el) {
      var key = 'al-viewing-' + (el.getAttribute('data-key') || 'default');
      var min = parseInt(el.getAttribute('data-min'), 10) || 12;
      var max = parseInt(el.getAttribute('data-max'), 10) || 19;
      var avoid = parseInt(el.getAttribute('data-avoid'), 10);
      if (max < min) max = min;

      function pick() {
        var value = min + Math.floor(Math.random() * (max - min + 1));
        if (!isNaN(avoid) && value === avoid && max > min) {
          value = value === max ? min : value + 1;
        }
        return value;
      }

      var n = min;
      try {
        var stored = parseInt(sessionStorage.getItem(key), 10);
        if (stored && !(stored === avoid)) {
          n = stored;
        } else {
          n = pick();
          sessionStorage.setItem(key, String(n));
        }
      } catch (err) {
        n = pick();
      }
      var slot = el.querySelector('[data-al-viewing-n]');
      if (slot) slot.textContent = n;
    });
  }

  function initToasts() {
    var root = document.querySelector('[data-al-toasts]');
    if (!root || root.dataset.alBound) return;
    var items = [];
    var jsonEl = document.getElementById('al-toast-messages');
    try {
      if (jsonEl) {
        items = JSON.parse(jsonEl.textContent || '[]');
      } else {
        var parsed = JSON.parse(root.getAttribute('data-messages') || '[]');
        items = typeof parsed === 'string' ? parsed.split(/\n/) : parsed;
      }
    } catch (err) {
      items = [];
    }
    items = items
      .map(function (line) {
        return String(line).replace(/<br\s*\/?>/gi, '').trim();
      })
      .filter(Boolean);
    if (!items.length) return;
    root.dataset.alBound = 'true';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    var i = 0;
    function show() {
      var msg = items[i % items.length];
      i += 1;
      root.textContent = msg;
      root.hidden = false;
      window.setTimeout(function () {
        root.hidden = true;
      }, 5200);
    }

    window.setTimeout(show, 9000);
    window.setInterval(show, 26000);
  }

  /* ------------------------------------------------ Carrito de la barra superior */
  function initTopbarCart() {
    if (document.body.dataset.alTopbarBound) return;
    document.body.dataset.alTopbarBound = 'true';

    document.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('[data-al-open-cart]');
      if (!btn) return;

      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        event.preventDefault();
        drawer.open(btn);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    });

    // El contador vive fuera del carrito lateral, así que Dawn no lo repinta.
    function refreshCount(count) {
      document.querySelectorAll('[data-al-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = !count;
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        fetch(cartUrl + '.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            refreshCount(cart.item_count);
          })
          .catch(function () {});
      });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-al-gallery]').forEach(initGallery);
    (scope || document).querySelectorAll('[data-al-buy]').forEach(initQuantity);
    initStickyBar();
    initAnchors();
    initAddToCart();
    initViewing();
    initToasts();
    initTopbarCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  // Re-inicializar al editar secciones en el editor de temas
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
